import style from './style.css';
import { h } from 'preact';

export function LoadingSpinner({
  height,
  width,
}: {
  height?: string;
  width?: string;
}) {
  return (
    <div
      className={style.loadingSpinner}
      style={{
        height: height ? height : '100%',
        width: width ? width : '100%',
      }}
    >
      <svg
        class={style.spinner}
        width="100%"
        height="100%"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class={style.path}
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  );
}

export function CenterLoadingSpinner() {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoadingSpinner height="60px" width="60px" />
    </div>
  );
}
